import React from "react";
import Text from "@/components/ui/text";

interface ToastBodyProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

const ToastBody: React.FC<ToastBodyProps> = ({ title, subtitle, actions }) => (
  <div className="flex w-full items-start justify-between gap-6">
    <div className="flex flex-1 flex-col gap-2">
      <Text variant="body" className="flex min-h-7 items-center">
        {title}
      </Text>
      {subtitle && (
        <div className="pb-2">
          <Text variant="bodySecondary">{subtitle}</Text>
        </div>
      )}
    </div>
    {actions && (
      <div className="flex items-center gap-1 self-center">{actions}</div>
    )}
  </div>
);

export default ToastBody;
